/* global $:true plyr:true */
/*
Store Locator Map Behaviour

This behaviour plugin controls the display of the map, its smarkers and the popover detail for the markers.

Markers can be defined in two ways:
1. through this components `addMarker` method, supplying lat, lng, icon and html (for the popover)
2. populating similar objects into the `data` option of this component:
    ```
    data-store-locator-map-data="[
        {lat: "", lng: "", icon: "", html: ""},
    ]"
    ```

If popover markup is present here in this component, then details are displayed when a marker is clicked.

Further reading: https://developers.google.com/maps/documentation/javascript/reference/3.exp/


Styleguide: STR001.Components.StoreLocatorMapBehaviour
*/

import debug from "debug";

import { MODULE_NAME } from './index';
import googleMapsApiPromise from '../../services/google-maps-api';
import debounce from '../../lib/debounce';

const log = debug(MODULE_NAME);

export class StoreLocatorSearch {

    constructor(element, options) {
        this.element = element;
        this.$element = $(element);
        this.$form = this.$element;
        this.options = options;

        if (this.element.nodeName != 'form') {
            this.$form = this.$element.find(this.options.formSelector);
        }

        log('construct', this.element, this.options);

        this.$addressField = this.$element.find(this.options.addressFieldSelector);
        this.$submitButton = this.$element.find(this.options.submitButtonSelector);
        this.$latField = this.$element.find(`[${this.options.latLngKeyAttribute}="lat"]`);
        this.$lngField = this.$element.find(`[${this.options.latLngKeyAttribute}="lng"]`);

        this.place = {};

        googleMapsApiPromise.then(this.init.bind(this));

    }

    init () {
        log('init');
        this.$form.on('submit', this.onSubmit.bind(this));
        this.$addressField.on('keypress', debounce(this.onKeyPress.bind(this), 150));
        this.$addressField.on('place_selected', this.onPlaceSelected.bind(this));

    }

    onKeyPress (event) {
        switch (event.keycode) {
            case 13:
                event.preventDefault();
                break;

            default:
                this.setFormLatLngValues('',''); //blanks out the form field values
                break;
        }
        return;
    }

    onPlaceSelected (event) {

        if (!this.submitOnchange) {
            log('place_selected.preventDefault', event);
            event.preventDefault && event.preventDefault();
        }

        const {place} = event;
        if (!place || !place.geometry) return;

        this.setSelectedPlace(place);

        if (this.submitOnchange) {
            this.$form.submit();
        }

    }

    onSubmit (event) {
        this.$submitButton.addClass('has-progress');
        this.setSelectedPlace(this.place());

    }

    setFormLatLngValues(lat, lng) {
        this.$latField.get(0).value = lat || '';
        this.$lngField.get(0).value = lng || '';
    }

    setSelectedPlace(place) {
        this.place = place;
        const {lat, lng} = this.getSelectedLatLng(place);
        log('setSelectedPlace', {name: this.$addressField.val(), lat, lng});
        this.setFormLatLngValues(lat, lng);
    }

    getSelectedLatLng (place) {
        if (!place) {
            return {};
        }
        const {lat, lng} = place.geometry.location;
        return {
            lat: lat(),
            lng: lng(),
        };
    }

}

StoreLocatorSearch.DEFAULTS = {
    submitOnchange: false,
    addressFieldSelector: '.store-locator-search__address-field',
    submitButtonSelector: '.store-locator-search__submit-button',
    latLngKeyAttribute: 'data-store-locator-search-latlng', // also used to build the selector
    formSelector: 'form',
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/store-locator-search/component.js